import { FormEvent, useState } from "react";
import { heroHotWords } from "@/mocks/guatrend";

interface Props {
  onSearch: (kw: string) => void;
}

export default function Hero({ onSearch }: Props) {
  const [kw, setKw] = useState("");

  const doSearch = (v: string) => {
    const val = v.trim();
    onSearch(val);
    document.getElementById("collection")?.scrollIntoView({ behavior: "smooth" });
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    doSearch(kw);
  };

  return (
    <section id="top" className="relative w-full">
      <div className="relative flex min-h-[600px] w-full items-center overflow-hidden md:h-[680px]">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cream%20and%20sage%20background%20with%20fresh%20watermelon%20slices%2C%20green%20leaves%20and%20soft%20books%20floating%20playfully%20in%20a%20gentle%20still%20life%2C%20cozy%20curated%20content%20editorial%20collage%2C%20matte%20texture%2C%20natural%20window%20light%2C%20inviting%20and%20clean%20atmosphere%2C%20modern%20graphic%20design%20style%2C%20high%20detail%2C%20balanced%20and%20harmonious%20composition&width=1600&height=900&seq=gua-hero-2026&orientation=landscape"
          alt="吃瓜精选口碑内容甄选背景"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>

        <div className="relative z-10 mx-auto w-full max-w-5xl px-4 py-24 text-center md:px-6">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/20 px-4 py-1.5 text-xs font-medium text-background-50 ring-1 ring-background-50/30 backdrop-blur">
            <i className="ri-fire-fill text-accent-400"></i>
            网友力荐 · 高分合集 · 口碑甄选
          </span>

          <h1 className="font-display mt-6 text-4xl leading-tight text-background-50 md:text-6xl">
            全网高分好瓜，
            <span className="text-primary-300">口碑甄选</span>一站集齐
          </h1>

          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-50/90 md:text-lg">
            吃瓜精选收集真实网友反馈与评分，逐期整理值得一看的高分合集与口碑内容。
            无论你是老瓜农还是新吃瓜人，都能在这里找到满意内容，口碑之选，放心食用。
          </p>

          <form
            onSubmit={handleSubmit}
            className="mx-auto mt-8 flex w-full max-w-xl flex-col gap-2 sm:flex-row"
          >
            <div className="relative flex-1">
              <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              <input
                type="text"
                value={kw}
                onChange={(e) => setKw(e.target.value)}
                placeholder="搜索想看的高分合集 / 口碑主题…"
                className="h-12 w-full rounded-full border-0 bg-background-50 pl-11 pr-4 text-sm text-foreground-800 outline-none placeholder:text-foreground-400 focus:ring-2 focus:ring-primary-400"
              />
            </div>
            <button
              type="submit"
              className="h-12 whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              开始找好瓜
            </button>
          </form>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
            <span className="text-xs text-background-50/70 whitespace-nowrap">大家都在搜：</span>
            {heroHotWords.map((w) => (
              <button
                key={w}
                type="button"
                onClick={() => doSearch(w)}
                className="whitespace-nowrap rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-50 ring-1 ring-background-50/25 transition-colors hover:bg-primary-500 hover:ring-primary-500"
              >
                {w}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}